import React from 'react';
import { MdOutlineFacebook } from 'react-icons/md';
import { BiLogoInstagramAlt, BiLogoYoutube } from 'react-icons/bi';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-r from-red-600 to-red-800 w-full py-12 mt-20">
      <div className="container mx-auto px-4">
        {/* Social Media Icons */}
        <div className="flex justify-center space-x-6 mb-6">
          <a 
            href="#" 
            className="text-white hover:text-green-400 transform hover:scale-110 transition-all duration-300"
            aria-label="Facebook"
          >
            <MdOutlineFacebook className="text-4xl" />
          </a>
          <a 
            href="#" 
            className="text-white hover:text-green-400 transform hover:scale-110 transition-all duration-300"
            aria-label="Instagram"
          >
            <BiLogoInstagramAlt className="text-4xl" />
          </a>
          <a 
            href="#" 
            className="text-white hover:text-green-400 transform hover:scale-110 transition-all duration-300"
            aria-label="YouTube"
          >
            <BiLogoYoutube className="text-4xl" />
          </a>
        </div>

        {/* Divider */}
        <div className="w-24 h-1 bg-green-500 mx-auto mb-6"></div>

        {/* Copyright Text */}
        <div className="text-center">
          <h4 className="text-white tracking-[.25em] font-medium text-lg">
            @smart-school
          </h4>
          <p className="text-gray-200 mt-2 text-sm">
            Empowering students through interactive learning
          </p>
        </div>

        {/* Quick Links */}
        <div className="flex justify-center mt-6 space-x-8">
          <a href="#" className="text-gray-200 hover:text-green-400 text-sm transition-colors duration-300">
            Privacy Policy
          </a>
          <a href="#" className="text-gray-200 hover:text-green-400 text-sm transition-colors duration-300">
            Terms of Service
          </a>
          <a href="#" className="text-gray-200 hover:text-green-400 text-sm transition-colors duration-300">
            Contact Us
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;